export default __webpack_public_path__ + "static/media/VaSeal.e943c192.png";